import { c as _c } from "react/compiler-runtime";
import { useState, type JSX } from 'react';
import type { Employee } from './types';
import { EmployeeAvatar } from '../avatar-employee';
import { EmployeeProfile } from '../employee-profile';
import type { EmployeeDetailsPopoverVariant } from '../employees-details-popover/types';
import { IconButton } from '../icon-button';
import { ControlledPopper } from '../popper';
export * from './types';
interface Props {
  employee: Employee;
  isWide?: boolean;
  onCopyEmail?: () => unknown;
  variant?: EmployeeDetailsPopoverVariant;
  hideEmailAddress?: boolean;
}
const REGULAR_SIZE = 32;
const WIDE_SIZE = 48;
export function EmployeeBadge(t0) {
  const $ = _c(31);
  const {
    employee,
    isWide,
    variant,
    onCopyEmail,
    hideEmailAddress
  } = t0;
  const boxWidth = isWide ? 352 : 328;
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsPopoverOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleOpen = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsPopoverOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClose = t2;
  let t3;
  if ($[2] !== employee.firstName?.[0] || $[3] !== employee.imageUrl || $[4] !== employee.lastName?.[0] || $[5] !== employee.type || $[6] !== isPopoverOpen || $[7] !== isWide) {
    t3 = t4 => {
      const {
        triggerRef
      } = t4;
      return <EmployeeAvatar ref={triggerRef} employeeType={employee.type} initials={`${employee?.firstName?.[0]}${employee?.lastName?.[0]}`} sizeInPixels={isWide ? WIDE_SIZE : REGULAR_SIZE} imageUrl={employee?.imageUrl} onClick={handleOpen} isActive={isPopoverOpen} />;
    };
    $[2] = employee.firstName?.[0];
    $[3] = employee.imageUrl;
    $[4] = employee.lastName?.[0];
    $[5] = employee.type;
    $[6] = isPopoverOpen;
    $[7] = isWide;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== boxWidth) {
    t4 = {
      width: boxWidth
    };
    $[9] = boxWidth;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute top-4 right-4"><IconButton type="close" onClick={handleClose} /></div>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = employee?.title;
  const t7 = employee?.phone;
  const t8 = employee?.extension;
  let t9;
  if ($[12] !== employee.departments || $[13] !== employee.email || $[14] !== employee.imageUrl || $[15] !== employee.name || $[16] !== employee.team || $[17] !== hideEmailAddress || $[18] !== onCopyEmail || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== variant) {
    t9 = <div className="flex flex-col"><EmployeeProfile variant={variant} name={employee.name} title={t6} imageUrl={employee.imageUrl} email={employee.email} phone={t7} extension={t8} departments={employee.departments} onCopyEmail={onCopyEmail} team={employee.team} hideEmailAddress={hideEmailAddress} /></div>;
    $[12] = employee.departments;
    $[13] = employee.email;
    $[14] = employee.imageUrl;
    $[15] = employee.name;
    $[16] = employee.team;
    $[17] = hideEmailAddress;
    $[18] = onCopyEmail;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = variant;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t4 || $[25] !== t9) {
    t10 = <div className="relative rounded-md border-[#aaa] bg-white p-4 shadow-lg" style={t4}>{t5}{t9}</div>;
    $[24] = t4;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== isPopoverOpen || $[28] !== t10 || $[29] !== t3) {
    t11 = <div className="flex items-center gap-3"><ControlledPopper isOpen={isPopoverOpen} onToggle={handleClose} portalElement={document.body} trigger={t3}>{t10}</ControlledPopper></div>;
    $[27] = isPopoverOpen;
    $[28] = t10;
    $[29] = t3;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
}